// // import React, {
// //   useMemo,
// //   useState,
// // } from 'react';

// // import {
// //   Link,
// //   useNavigate,
// // } from 'react-router-dom';

// // import {
// //   motion,
// // } from 'framer-motion';

// // import './DignitaryList.css';


// // const API_URL =
// //   process.env.REACT_APP_API_URL ||
// //   'http://localhost:3001';


// // export default function DignitaryList() {

// //   const navigate =
// //     useNavigate();


// //   const [
// //     adminKey,
// //     setAdminKey,
// //   ] = useState(
// //     () =>
// //       sessionStorage.getItem(
// //         'birthday_admin_key'
// //       ) || ''
// //   );


// //   const [
// //     dignitaries,
// //     setDignitaries,
// //   ] = useState([]);


// //   const [
// //     loading,
// //     setLoading,
// //   ] = useState(false);


// //   const [
// //     error,
// //     setError,
// //   ] = useState('');


// //   const [
// //     search,
// //     setSearch,
// //   ] = useState('');


// //   const [
// //     copiedCode,
// //     setCopiedCode,
// //   ] = useState('');


// //   /**
// //    * ==========================
// //    * FETCH DIGNITARIES
// //    * ==========================
// //    */

// //   const fetchDignitaries =
// //     async (event) => {

// //       if (event) {
// //         event.preventDefault();
// //       }


// //       const key =
// //         adminKey.trim();


// //       if (!key) {

// //         setError(
// //           'Enter your admin key.'
// //         );

// //         return;
// //       }


// //       try {

// //         setLoading(true);

// //         setError('');


// //         const response =
// //           await fetch(
// //             `${API_URL}/api/birthday/admin/dignitaries`,
// //             {
// //               method:
// //                 'GET',

// //               headers: {
// //                 'x-admin-key':
// //                   key,
// //               },
// //             }
// //           );


// //         const result =
// //           await response.json();


// //         if (
// //           !response.ok ||
// //           !result.success
// //         ) {

// //           throw new Error(
// //             result.message ||
// //               'Unable to fetch dignitaries.'
// //           );

// //         }


// //         sessionStorage.setItem(
// //           'birthday_admin_key',
// //           key
// //         );


// //         setDignitaries(
// //           Array.isArray(
// //             result.data
// //           )
// //             ? result.data
// //             : []
// //         );

// //       } catch (err) {

// //         setDignitaries([]);

// //         setError(
// //           err.message ||
// //             'Unable to fetch dignitaries.'
// //         );

// //       } finally {

// //         setLoading(false);

// //       }

// //     };


// //   /**
// //    * ==========================
// //    * FILTER
// //    * ==========================
// //    */

// //   const filtered =
// //     useMemo(() => {

// //       const query =
// //         search
// //           .trim()
// //           .toLowerCase();


// //       if (!query) {

// //         return dignitaries;

// //       }


// //       return dignitaries.filter(
// //         (dignitary) => {

// //           const fullName =
// //             String(
// //               dignitary.fullName ||
// //                 ''
// //             ).toLowerCase();


// //           const invitationCode =
// //             String(
// //               dignitary.invitationCode ||
// //                 ''
// //             ).toLowerCase();


// //           return (
// //             fullName.includes(
// //               query
// //             ) ||
// //             invitationCode.includes(
// //               query
// //             )
// //           );

// //         }
// //       );

// //     }, [
// //       dignitaries,
// //       search,
// //     ]);


// //   /**
// //    * ==========================
// //    * COPY CODE
// //    * ==========================
// //    */

// //   const copyCode =
// //     async (code) => {

// //       try {

// //         await navigator.clipboard.writeText(
// //           code
// //         );


// //         setCopiedCode(
// //           code
// //         );


// //         setTimeout(
// //           () => {
// //             setCopiedCode('');
// //           },
// //           1500
// //         );

// //       } catch {

// //         setError(
// //           'Unable to copy invitation code.'
// //         );

// //       }

// //     };


// //   /**
// //    * ==========================
// //    * OPEN INVITATION
// //    * ==========================
// //    */

// //   const openInvitation =
// //     (code) => {

// //       navigate(
// //         `/invitation/${encodeURIComponent(
// //           code
// //         )}`
// //       );

// //     };


// //   return (

// //     <div className="vip-admin-page">


// //       <motion.section

// //         className="vip-admin-card"

// //         initial={{
// //           opacity: 0,
// //           y: 20,
// //         }}

// //         animate={{
// //           opacity: 1,
// //           y: 0,
// //         }}

// //       >

// //         <span className="vip-admin-eyebrow">

// //           COS Birthday Celebration

// //         </span>


// //         <h1>

// //           VIP Invitations

// //         </h1>


// //         <p className="vip-admin-intro">

// //           View registered dignitaries and
// //           their private invitation codes.

// //         </p>


// //         {/* ==========================
// //             ADMIN ACCESS
// //         ========================== */}

// //         <form
// //           className="vip-admin-login"
// //           onSubmit={
// //             fetchDignitaries
// //           }
// //         >

// //           <label htmlFor="vip-admin-key">

// //             Admin Key

// //           </label>


// //           <div className="vip-admin-login-row">

// //             <input

// //               id="vip-admin-key"

// //               type="password"

// //               placeholder="Enter admin key"

// //               value={
// //                 adminKey
// //               }

// //               onChange={(
// //                 event
// //               ) => {

// //                 setAdminKey(
// //                   event.target.value
// //                 );

// //                 if (error) {
// //                   setError('');
// //                 }

// //               }}

// //               autoComplete="off"

// //             />


// //             <button
// //               type="submit"
// //               disabled={
// //                 loading
// //               }
// //             >

// //               {loading
// //                 ? 'Loading...'
// //                 : 'Fetch VIPs'}

// //             </button>

// //           </div>

// //         </form>


// //         {error && (

// //           <div
// //             className="vip-admin-error"
// //             role="alert"
// //           >

// //             {error}

// //           </div>

// //         )}


// //         {/* ==========================
// //             RESULT AREA
// //         ========================== */}

// //         {dignitaries.length > 0 && (

// //           <>

// //             <div className="vip-admin-toolbar">

// //               <div>

// //                 <strong>
// //                   {
// //                     dignitaries.length
// //                   }
// //                 </strong>

// //                 <span>
// //                   {' '}
// //                   dignitar{
// //                     dignitaries.length ===
// //                     1
// //                       ? 'y'
// //                       : 'ies'
// //                   }
// //                 </span>

// //               </div>


// //               <input

// //                 type="search"

// //                 placeholder="Search name or invitation code..."

// //                 value={
// //                   search
// //                 }

// //                 onChange={(
// //                   event
// //                 ) =>
// //                   setSearch(
// //                     event.target.value
// //                   )
// //                 }

// //               />

// //             </div>


// //             <div className="vip-admin-list">

// //               {filtered.length >
// //               0 ? (

// //                 filtered.map(
// //                   (
// //                     dignitary,
// //                     index
// //                   ) => (

// //                     <motion.div

// //                       className="vip-admin-row"

// //                       key={
// //                         dignitary.id ||
// //                         dignitary.invitationCode
// //                       }

// //                       initial={{
// //                         opacity: 0,
// //                         y: 10,
// //                       }}

// //                       animate={{
// //                         opacity: 1,
// //                         y: 0,
// //                       }}

// //                       transition={{
// //                         delay:
// //                           index *
// //                           0.025,
// //                       }}

// //                     >

// //                       <div className="vip-admin-number">

// //                         {String(
// //                           index + 1
// //                         ).padStart(
// //                           2,
// //                           '0'
// //                         )}

// //                       </div>


// //                       <div className="vip-admin-person">

// //                         <span>
// //                           Full Name
// //                         </span>

// //                         <strong>
// //                           {
// //                             dignitary.fullName
// //                           }
// //                         </strong>

// //                       </div>


// //                       <div className="vip-admin-code">

// //                         <span>
// //                           Invitation Code
// //                         </span>

// //                         <strong>
// //                           {
// //                             dignitary.invitationCode
// //                           }
// //                         </strong>

// //                       </div>


// //                       <div className="vip-admin-actions">

// //                         <button
// //                           type="button"
// //                           onClick={() =>
// //                             copyCode(
// //                               dignitary.invitationCode
// //                             )
// //                           }
// //                         >

// //                           {copiedCode ===
// //                           dignitary.invitationCode
// //                             ? 'Copied ✓'
// //                             : 'Copy Code'}

// //                         </button>


// //                         <button
// //                           type="button"
// //                           className="vip-admin-open"
// //                           onClick={() =>
// //                             openInvitation(
// //                               dignitary.invitationCode
// //                             )
// //                           }
// //                         >

// //                           View Invite

// //                         </button>

// //                       </div>

// //                     </motion.div>

// //                   )
// //                 )

// //               ) : (

// //                 <div className="vip-admin-empty">

// //                   No dignitary matches
// //                   your search.

// //                 </div>

// //               )}

// //             </div>

// //           </>

// //         )}


// //         {!loading &&
// //           !error &&
// //           dignitaries.length ===
// //             0 && (

// //             <div className="vip-admin-empty">

// //               Enter your admin key and
// //               click Fetch VIPs.

// //             </div>

// //           )}


// //         <Link
// //           to="/"
// //           className="vip-admin-back"
// //         >

// //           ← Back Home

// //         </Link>

// //       </motion.section>

// //     </div>

// //   );

// // }



// import React, {
//   useMemo,
//   useState,
// } from 'react';

// import {
//   Link,
//   useNavigate,
// } from 'react-router-dom';

// import {
//   motion,
// } from 'framer-motion';

// import './DignitaryList.css';


// const API_URL =
//   process.env.REACT_APP_API_URL ||
//   'https://lsdcnodejs-api.onrender.com';


// const PasswordEyeIcon = ({ visible }) => (
//   visible ? (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 3L21 21"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />
//       <path
//         d="M10.6 10.7A2 2 0 0013.3 13.4"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />
//       <path
//         d="M9.9 4.3A10.6 10.6 0 0112 4c5.4 0 9 5.2 9 5.2a14.4 14.4 0 01-3 3.6M6.1 6.1C4.2 7.3 3 9.2 3 9.2S6.6 14.4 12 14.4c1 0 1.9-.2 2.7-.5"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ) : (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 12s3.6-5.2 9-5.2S21 12 21 12s-3.6 5.2-9 5.2S3 12 3 12z"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <circle
//         cx="12"
//         cy="12"
//         r="2.6"
//         stroke="currentColor"
//         strokeWidth="1.8"
//       />
//     </svg>
//   )
// );


// const passwordWrapStyle = {
//   position: 'relative',
//   width: '100%',
// };


// const passwordInputStyle = {
//   width: '100%',
//   boxSizing: 'border-box',
//   paddingRight: '48px',
// };


// const passwordEyeButtonStyle = {
//   position: 'absolute',
//   top: '50%',
//   right: '14px',
//   transform: 'translateY(-50%)',
//   width: '32px',
//   minWidth: '32px',
//   height: '32px',
//   minHeight: '32px',
//   padding: 0,
//   margin: 0,
//   display: 'grid',
//   placeItems: 'center',
//   border: 'none',
//   borderRadius: '50%',
//   background: 'transparent',
//   boxShadow: 'none',
//   color: '#c6a15b',
//   cursor: 'pointer',
//   zIndex: 3,
// };



// export default function DignitaryList() {

//   const navigate =
//     useNavigate();


//   const [
//     adminKey,
//     setAdminKey,
//   ] = useState(
//     () =>
//       sessionStorage.getItem(
//         'birthday_admin_key'
//       ) || ''
//   );


//   const [
//     showAdminKey,
//     setShowAdminKey,
//   ] = useState(false);


//   const [
//     dignitaries,
//     setDignitaries,
//   ] = useState([]);


//   const [
//     loading,
//     setLoading,
//   ] = useState(false);


//   const [
//     error,
//     setError,
//   ] = useState('');


//   const [
//     search,
//     setSearch,
//   ] = useState('');


//   const [
//     copiedCode,
//     setCopiedCode,
//   ] = useState('');


//   /**
//    * ==========================
//    * FETCH DIGNITARIES
//    * ==========================
//    */

//   const fetchDignitaries =
//     async (event) => {

//       if (event) {
//         event.preventDefault();
//       }


//       const key =
//         adminKey.trim();


//       if (!key) {

//         setError(
//           'Enter your admin key.'
//         );

//         return;
//       }


//       try {

//         setLoading(true);

//         setError('');


//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/admin/dignitaries`,
//             {
//               method:
//                 'GET',

//               headers: {
//                 'x-admin-key':
//                   key,
//               },
//             }
//           );


//         const result =
//           await response.json();


//         if (
//           !response.ok ||
//           !result.success
//         ) {

//           throw new Error(
//             result.message ||
//               'Unable to fetch dignitaries.'
//           );

//         }


//         sessionStorage.setItem(
//           'birthday_admin_key',
//           key
//         );


//         setDignitaries(
//           Array.isArray(
//             result.data
//           )
//             ? result.data
//             : []
//         );

//       } catch (err) {

//         setDignitaries([]);

//         setError(
//           err.message ||
//             'Unable to fetch dignitaries.'
//         );

//       } finally {

//         setLoading(false);

//       }

//     };


//   /**
//    * ==========================
//    * FILTER
//    * ==========================
//    */

//   const filtered =
//     useMemo(() => {

//       const query =
//         search
//           .trim()
//           .toLowerCase();


//       if (!query) {

//         return dignitaries;

//       }


//       return dignitaries.filter(
//         (dignitary) => {

//           const fullName =
//             String(
//               dignitary.fullName ||
//                 ''
//             ).toLowerCase();


//           const invitationCode =
//             String(
//               dignitary.invitationCode ||
//                 ''
//             ).toLowerCase();


//           return (
//             fullName.includes(
//               query
//             ) ||
//             invitationCode.includes(
//               query
//             )
//           );

//         }
//       );

//     }, [
//       dignitaries,
//       search,
//     ]);


//   /**
//    * ==========================
//    * COPY CODE
//    * ==========================
//    */

//   const copyCode =
//     async (code) => {

//       try {

//         await navigator.clipboard.writeText(
//           code
//         );


//         setCopiedCode(
//           code
//         );


//         setTimeout(
//           () => {
//             setCopiedCode('');
//           },
//           1500
//         );

//       } catch {

//         setError(
//           'Unable to copy invitation code.'
//         );

//       }

//     };


//   /**
//    * ==========================
//    * OPEN INVITATION
//    * ==========================
//    */

//   const openInvitation =
//     (code) => {

//       navigate(
//         `/invitation/${encodeURIComponent(
//           code
//         )}`
//       );

//     };


//   return (

//     <div className="vip-admin-page">


//       <motion.section

//         className="vip-admin-card"

//         initial={{
//           opacity: 0,
//           y: 20,
//         }}

//         animate={{
//           opacity: 1,
//           y: 0,
//         }}

//       >

//         <span className="vip-admin-eyebrow">

//           COS Birthday Celebration

//         </span>


//         <h1>

//           VIP Invitations

//         </h1>


//         <p className="vip-admin-intro">

//           View registered dignitaries and
//           their private invitation codes.

//         </p>


//         {/* ==========================
//             ADMIN ACCESS
//         ========================== */}

//         <form
//           className="vip-admin-login"
//           onSubmit={
//             fetchDignitaries
//           }
//         >

//           <label htmlFor="vip-admin-key">

//             Admin Key

//           </label>


//           <div className="vip-admin-login-row">

//             <div style={passwordWrapStyle}>

//               <input

//                 id="vip-admin-key"

//                 type={
//                   showAdminKey
//                     ? 'text'
//                     : 'password'
//                 }

//                 placeholder="Enter admin key"

//                 value={
//                   adminKey
//                 }

//                 onChange={(
//                   event
//                 ) => {

//                   setAdminKey(
//                     event.target.value
//                   );

//                   if (error) {
//                     setError('');
//                   }

//                 }}

//                 autoComplete="off"

//                 style={passwordInputStyle}

//               />


//               <button
//                 type="button"
//                 onClick={() =>
//                   setShowAdminKey(
//                     (current) => !current
//                   )
//                 }
//                 aria-label={
//                   showAdminKey
//                     ? 'Hide admin key'
//                     : 'Show admin key'
//                 }
//                 title={
//                   showAdminKey
//                     ? 'Hide password'
//                     : 'Show password'
//                 }
//                 style={passwordEyeButtonStyle}
//               >
//                 <PasswordEyeIcon
//                   visible={showAdminKey}
//                 />
//               </button>

//             </div>


//             <button
//               type="submit"
//               disabled={
//                 loading
//               }
//             >

//               {loading
//                 ? 'Loading...'
//                 : 'Fetch VIPs'}

//             </button>

//           </div>

//         </form>


//         {error && (

//           <div
//             className="vip-admin-error"
//             role="alert"
//           >

//             {error}

//           </div>

//         )}


//         {/* ==========================
//             RESULT AREA
//         ========================== */}

//         {dignitaries.length > 0 && (

//           <>

//             <div className="vip-admin-toolbar">

//               <div>

//                 <strong>
//                   {
//                     dignitaries.length
//                   }
//                 </strong>

//                 <span>
//                   {' '}
//                   dignitar{
//                     dignitaries.length ===
//                     1
//                       ? 'y'
//                       : 'ies'
//                   }
//                 </span>

//               </div>


//               <input

//                 type="search"

//                 placeholder="Search name or invitation code..."

//                 value={
//                   search
//                 }

//                 onChange={(
//                   event
//                 ) =>
//                   setSearch(
//                     event.target.value
//                   )
//                 }

//               />

//             </div>


//             <div className="vip-admin-list">

//               {filtered.length >
//               0 ? (

//                 filtered.map(
//                   (
//                     dignitary,
//                     index
//                   ) => (

//                     <motion.div

//                       className="vip-admin-row"

//                       key={
//                         dignitary.id ||
//                         dignitary.invitationCode
//                       }

//                       initial={{
//                         opacity: 0,
//                         y: 10,
//                       }}

//                       animate={{
//                         opacity: 1,
//                         y: 0,
//                       }}

//                       transition={{
//                         delay:
//                           index *
//                           0.025,
//                       }}

//                     >

//                       <div className="vip-admin-number">

//                         {String(
//                           index + 1
//                         ).padStart(
//                           2,
//                           '0'
//                         )}

//                       </div>


//                       <div className="vip-admin-person">

//                         <span>
//                           Full Name
//                         </span>

//                         <strong>
//                           {
//                             dignitary.fullName
//                           }
//                         </strong>

//                       </div>


//                       <div className="vip-admin-code">

//                         <span>
//                           Invitation Code
//                         </span>

//                         <strong>
//                           {
//                             dignitary.invitationCode
//                           }
//                         </strong>

//                       </div>


//                       <div className="vip-admin-actions">

//                         <button
//                           type="button"
//                           onClick={() =>
//                             copyCode(
//                               dignitary.invitationCode
//                             )
//                           }
//                         >

//                           {copiedCode ===
//                           dignitary.invitationCode
//                             ? 'Copied ✓'
//                             : 'Copy Code'}

//                         </button>


//                         <button
//                           type="button"
//                           className="vip-admin-open"
//                           onClick={() =>
//                             openInvitation(
//                               dignitary.invitationCode
//                             )
//                           }
//                         >

//                           View Invite

//                         </button>

//                       </div>

//                     </motion.div>

//                   )
//                 )

//               ) : (

//                 <div className="vip-admin-empty">

//                   No dignitary matches
//                   your search.

//                 </div>

//               )}

//             </div>

//           </>

//         )}


//         {!loading &&
//           !error &&
//           dignitaries.length ===
//             0 && (

//             <div className="vip-admin-empty">

//               Enter your admin key and
//               click Fetch VIPs.

//             </div>

//           )}


//         <Link
//           to="/"
//           className="vip-admin-back"
//         >

//           ← Back Home

//         </Link>

//       </motion.section>

//     </div>

//   );

// }




// import React, {
//   useMemo,
//   useState,
// } from 'react';

// import {
//   Link,
//   useNavigate,
// } from 'react-router-dom';

// import {
//   motion,
// } from 'framer-motion';

// import './DignitaryList.css';


// const API_URL =
//   process.env.REACT_APP_API_URL ||
//   'https://lsdcnodejs-api.onrender.com';


// const PasswordEyeIcon = ({ visible }) => (
//   visible ? (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 3L21 21"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />
//       <path
//         d="M10.6 10.7A2 2 0 0013.3 13.4"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />
//       <path
//         d="M9.9 4.3A10.6 10.6 0 0112 4c5.4 0 9 5.2 9 5.2a14.4 14.4 0 01-3 3.6M6.1 6.1C4.2 7.3 3 9.2 3 9.2S6.6 14.4 12 14.4c1 0 1.9-.2 2.7-.5"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ) : (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 12s3.6-5.2 9-5.2S21 12 21 12s-3.6 5.2-9 5.2S3 12 3 12z"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <circle
//         cx="12"
//         cy="12"
//         r="2.6"
//         stroke="currentColor"
//         strokeWidth="1.8"
//       />
//     </svg>
//   )
// );


// const passwordWrapStyle = {
//   position: 'relative',
//   width: '100%',
// };


// const passwordInputStyle = {
//   width: '100%',
//   boxSizing: 'border-box',
//   paddingRight: '48px',
// };


// const passwordEyeButtonStyle = {
//   position: 'absolute',
//   top: '50%',
//   right: '14px',
//   transform: 'translateY(-50%)',
//   width: '32px',
//   minWidth: '32px',
//   height: '32px',
//   minHeight: '32px',
//   padding: 0,
//   margin: 0,
//   display: 'grid',
//   placeItems: 'center',
//   border: 'none',
//   borderRadius: '50%',
//   background: 'transparent',
//   boxShadow: 'none',
//   color: '#c6a15b',
//   cursor: 'pointer',
//   zIndex: 3,
// };



// /* =========================================================
//    INVITATION / KINGCHAT HELPERS

//    Same message as DignitarySuperMin (Copy Invite Message).
//    This is a manual workflow; no automatic KingsChat send.
// ========================================================= */

// const normalizeKcUsername = (value) =>
//   String(value ?? '')
//     .trim()
//     .replace(/^@+/, '')
//     .toLowerCase();


// const getKcUsername = (person) =>
//   normalizeKcUsername(
//     person?.kcusername ||
//     person?.kc_username ||
//     ''
//   );


// const getKingsChatProfileUrl = (person) => {
//   const username = getKcUsername(person);
//   return username
//     ? `https://kingschat.online/user/${encodeURIComponent(username)}`
//     : '';
// };


// const getInvitationLink = (person) => {
//   const code = String(person?.invitationCode || '').trim();
//   return code
//     ? `${window.location.origin}/invitation/${encodeURIComponent(code)}`
//     : '';
// };


// const formatInviteeSalutation = (fullName = '') => {
//   const name = String(fullName || '').trim();
//   if (!name) return 'Esteemed Guest';
//   return /^esteemed\b/i.test(name) ? name : `Esteemed ${name}`;
// };


// const buildInvitationMessage = (person) => {
//   const name = formatInviteeSalutation(person?.fullName);
//   const link = getInvitationLink(person);

//   return `*SPECIAL INVITATION TO THE BIRTHDAY CELEBRATION, THANKSGIVING AND BANQUET OF THE HIGHLY ESTEEMED CHIEF OF STAFF, LOVEWORLD NATION; PASTOR BISOLA ADEYEMI*

// Dear ${name},

// Greetings in the precious Name of our Lord Jesus Christ.

// We are delighted to invite you to the Birthday Celebration of our Highly Esteemed Chief of Staff, Pastor Bisola Adeyemi, scheduled to hold on *Tuesday, 6th October 2026*.

// *Event Details:*
// *Thanksgiving Service*: Bay 4, 10am prompt

// *Banquet*: The Angel Court, Immediately after the Thanksgiving

// Kindly click the link below to confirm your attendance, so your SEAT NUMBER can be sent to you.

// Link:
// ${link}

// We look forward to warmly welcoming you.

// Kind regards,
// *The Organising Committee*`;
// };


// /* Copy supports both secure clipboard and a legacy fallback. */
// const copyTextToClipboard = async (text) => {
//   const value = String(text || '').trim();
//   if (!value) throw new Error('Nothing available to copy.');

//   if (navigator.clipboard && window.isSecureContext) {
//     try {
//       await navigator.clipboard.writeText(value);
//       return;
//     } catch {
//       // Try the fallback below when browser permissions reject access.
//     }
//   }

//   const textarea = document.createElement('textarea');
//   textarea.value = value;
//   textarea.setAttribute('readonly', '');
//   textarea.style.position = 'fixed';
//   textarea.style.left = '-9999px';
//   textarea.style.opacity = '0';
//   document.body.appendChild(textarea);
//   textarea.focus();
//   textarea.select();
//   const ok = document.execCommand('copy');
//   textarea.remove();
//   if (!ok) throw new Error('Could not copy message.');
// };


// export default function DignitaryList() {

//   const navigate =
//     useNavigate();


//   const [
//     adminKey,
//     setAdminKey,
//   ] = useState(
//     () =>
//       sessionStorage.getItem(
//         'birthday_admin_key'
//       ) || ''
//   );


//   const [
//     showAdminKey,
//     setShowAdminKey,
//   ] = useState(false);


//   const [
//     dignitaries,
//     setDignitaries,
//   ] = useState([]);


//   const [
//     loading,
//     setLoading,
//   ] = useState(false);


//   const [
//     error,
//     setError,
//   ] = useState('');


//   const [
//     search,
//     setSearch,
//   ] = useState('');


//   const [
//     copiedCode,
//     setCopiedCode,
//   ] = useState('');

//   const [
//     copiedMessage,
//     setCopiedMessage,
//   ] = useState('');

//   const [
//     preparedInvite,
//     setPreparedInvite,
//   ] = useState('');


//   /**
//    * ==========================
//    * FETCH DIGNITARIES
//    * ==========================
//    */

//   const fetchDignitaries =
//     async (event) => {

//       if (event) {
//         event.preventDefault();
//       }


//       const key =
//         adminKey.trim();


//       if (!key) {

//         setError(
//           'Enter your admin key.'
//         );

//         return;
//       }


//       try {

//         setLoading(true);

//         setError('');


//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/admin/dignitaries`,
//             {
//               method:
//                 'GET',

//               headers: {
//                 'x-admin-key':
//                   key,
//               },
//             }
//           );


//         const result =
//           await response.json();


//         if (
//           !response.ok ||
//           !result.success
//         ) {

//           throw new Error(
//             result.message ||
//               'Unable to fetch dignitaries.'
//           );

//         }


//         sessionStorage.setItem(
//           'birthday_admin_key',
//           key
//         );


//         setDignitaries(
//           Array.isArray(
//             result.data
//           )
//             ? result.data
//             : []
//         );

//       } catch (err) {

//         setDignitaries([]);

//         setError(
//           err.message ||
//             'Unable to fetch dignitaries.'
//         );

//       } finally {

//         setLoading(false);

//       }

//     };


//   /**
//    * ==========================
//    * FILTER
//    * ==========================
//    */

//   const filtered =
//     useMemo(() => {

//       const query =
//         search
//           .trim()
//           .toLowerCase();


//       if (!query) {

//         return dignitaries;

//       }


//       return dignitaries.filter(
//         (dignitary) => {

//           const fullName =
//             String(
//               dignitary.fullName ||
//                 ''
//             ).toLowerCase();


//           const invitationCode =
//             String(
//               dignitary.invitationCode ||
//                 ''
//             ).toLowerCase();


//           return (
//             fullName.includes(
//               query
//             ) ||
//             invitationCode.includes(
//               query
//             )
//           );

//         }
//       );

//     }, [
//       dignitaries,
//       search,
//     ]);


//   /**
//    * ==========================
//    * COPY CODE
//    * ==========================
//    */

//   const copyCode =
//     async (code) => {

//       try {

//         await copyTextToClipboard(
//           code
//         );


//         setCopiedCode(
//           code
//         );


//         setTimeout(
//           () => {
//             setCopiedCode('');
//           },
//           1500
//         );

//       } catch {

//         setError(
//           'Unable to copy invitation code.'
//         );

//       }

//     };


//   /* =========================================================
//      COPY PERSONALISED INVITATION MESSAGE
//   ========================================================= */
//   const copyInviteMessage = async (person) => {
//     try {
//       setError('');
//       await copyTextToClipboard(buildInvitationMessage(person));
//       const code = person.invitationCode;
//       setCopiedMessage(code);
//       setTimeout(() => setCopiedMessage(''), 1800);
//     } catch {
//       setError('Unable to copy this invitation message.');
//     }
//   };


//   /* =========================================================
//      SEND INVITE (MANUAL KINGCHAT)

//      The <a> opens a real KingsChat profile from the click.
//      We start the clipboard operation synchronously within
//      the click to preserve browser permission. The admin then
//      pastes and sends the invitation inside KingsChat.
//   ========================================================= */
//   const prepareKingsChatInvite = (person) => {
//     setError('');
//     const code = person.invitationCode;
//     const message = buildInvitationMessage(person);

//     // Start copying while the user activation is still active.
//     copyTextToClipboard(message)
//       .then(() => {
//         setPreparedInvite(code);
//         setTimeout(() => setPreparedInvite(''), 2500);
//       })
//       .catch(() => {
//         setError(
//           'KingsChat opened, but the message could not be copied. Use Copy Message, then paste it in KingsChat.'
//         );
//       });
//   };


//   /**
//    * ==========================
//    * OPEN INVITATION
//    * ==========================
//    */

//   const openInvitation =
//     (code) => {

//       navigate(
//         `/invitation/${encodeURIComponent(
//           code
//         )}`
//       );

//     };


//   return (

//     <div className="vip-admin-page">


//       <motion.section

//         className="vip-admin-card"

//         initial={{
//           opacity: 0,
//           y: 20,
//         }}

//         animate={{
//           opacity: 1,
//           y: 0,
//         }}

//       >

//         <span className="vip-admin-eyebrow">

//           COS Birthday Celebration

//         </span>


//         <h1>

//           VIP Invitations

//         </h1>


//         <p className="vip-admin-intro">

//           View your dignitaries, copy personalised invite messages,
//           and open their KingsChat profiles to send each invitation.

//         </p>


//         {/* ==========================
//             ADMIN ACCESS
//         ========================== */}

//         <form
//           className="vip-admin-login"
//           onSubmit={
//             fetchDignitaries
//           }
//         >

//           <label htmlFor="vip-admin-key">

//             Admin Key

//           </label>


//           <div className="vip-admin-login-row">

//             <div style={passwordWrapStyle}>

//               <input

//                 id="vip-admin-key"

//                 type={
//                   showAdminKey
//                     ? 'text'
//                     : 'password'
//                 }

//                 placeholder="Enter admin key"

//                 value={
//                   adminKey
//                 }

//                 onChange={(
//                   event
//                 ) => {

//                   setAdminKey(
//                     event.target.value
//                   );

//                   if (error) {
//                     setError('');
//                   }

//                 }}

//                 autoComplete="off"

//                 style={passwordInputStyle}

//               />


//               <button
//                 type="button"
//                 onClick={() =>
//                   setShowAdminKey(
//                     (current) => !current
//                   )
//                 }
//                 aria-label={
//                   showAdminKey
//                     ? 'Hide admin key'
//                     : 'Show admin key'
//                 }
//                 title={
//                   showAdminKey
//                     ? 'Hide password'
//                     : 'Show password'
//                 }
//                 style={passwordEyeButtonStyle}
//               >
//                 <PasswordEyeIcon
//                   visible={showAdminKey}
//                 />
//               </button>

//             </div>


//             <button
//               type="submit"
//               disabled={
//                 loading
//               }
//             >

//               {loading
//                 ? 'Loading...'
//                 : 'Fetch VIPs'}

//             </button>

//           </div>

//         </form>


//         {error && (

//           <div
//             className="vip-admin-error"
//             role="alert"
//           >

//             {error}

//           </div>

//         )}


//         {/* ==========================
//             RESULT AREA
//         ========================== */}

//         {dignitaries.length > 0 && (

//           <>

//             <div className="vip-admin-toolbar">

//               <div>

//                 <strong>
//                   {
//                     dignitaries.length
//                   }
//                 </strong>

//                 <span>
//                   {' '}
//                   dignitar{
//                     dignitaries.length ===
//                     1
//                       ? 'y'
//                       : 'ies'
//                   }
//                 </span>

//               </div>


//               <input

//                 type="search"

//                 placeholder="Search name, KingsChat username or invitation code..."

//                 value={
//                   search
//                 }

//                 onChange={(
//                   event
//                 ) =>
//                   setSearch(
//                     event.target.value
//                   )
//                 }

//               />

//             </div>


//             <div className="vip-admin-list">

//               {filtered.length >
//               0 ? (

//                 filtered.map(
//                   (
//                     dignitary,
//                     index
//                   ) => (

//                     <motion.div

//                       className="vip-admin-row"

//                       key={
//                         dignitary.id ||
//                         dignitary.invitationCode
//                       }

//                       initial={{
//                         opacity: 0,
//                         y: 10,
//                       }}

//                       animate={{
//                         opacity: 1,
//                         y: 0,
//                       }}

//                       transition={{
//                         delay:
//                           index *
//                           0.025,
//                       }}

//                     >

//                       <div className="vip-admin-number">

//                         {String(
//                           index + 1
//                         ).padStart(
//                           2,
//                           '0'
//                         )}

//                       </div>


//                       <div className="vip-admin-person">

//                         <span>
//                           Full Name
//                         </span>

//                         <strong>
//                           {
//                             dignitary.fullName
//                           }
//                         </strong>

//                         {getKcUsername(dignitary) ? (
//                           <span className="vip-admin-kcusername">
//                             KingsChat · @{getKcUsername(dignitary)}
//                           </span>
//                         ) : (
//                           <span className="vip-admin-kcusername vip-admin-kcusername--missing">
//                             No KingsChat username on record
//                           </span>
//                         )}

//                       </div>


//                       <div className="vip-admin-code">

//                         <span>
//                           Invitation Code
//                         </span>

//                         <strong>
//                           {
//                             dignitary.invitationCode
//                           }
//                         </strong>

//                       </div>


//                       <div className="vip-admin-actions">

//                         <button
//                           type="button"
//                           onClick={() =>
//                             copyCode(
//                               dignitary.invitationCode
//                             )
//                           }
//                         >

//                           {copiedCode ===
//                           dignitary.invitationCode
//                             ? 'Copied ✓'
//                             : 'Copy Code'}

//                         </button>


//                         <button
//                           type="button"
//                           className="vip-admin-copy-message"
//                           onClick={() => copyInviteMessage(dignitary)}
//                           disabled={!dignitary.invitationCode}
//                         >
//                           {copiedMessage === dignitary.invitationCode
//                             ? 'Message Copied ✓'
//                             : 'Copy Message'}
//                         </button>

//                         {getKingsChatProfileUrl(dignitary) ? (
//                           <a
//                             className="vip-admin-send"
//                             href={getKingsChatProfileUrl(dignitary)}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             onClick={() => prepareKingsChatInvite(dignitary)}
//                             title="Open KingsChat profile and copy message to paste"
//                           >
//                             {preparedInvite === dignitary.invitationCode
//                               ? 'Copied · Ready to Paste ✓'
//                               : 'Send Invite'}
//                           </a>
//                         ) : (
//                           <button
//                             type="button"
//                             className="vip-admin-send"
//                             disabled
//                             title="KingsChat username is missing"
//                           >
//                             Send Invite
//                           </button>
//                         )}

//                         <button
//                           type="button"
//                           className="vip-admin-open"
//                           onClick={() =>
//                             openInvitation(
//                               dignitary.invitationCode
//                             )
//                           }
//                         >

//                           View Invite

//                         </button>

//                       </div>

//                     </motion.div>

//                   )
//                 )

//               ) : (

//                 <div className="vip-admin-empty">

//                   No dignitary matches
//                   your search.

//                 </div>

//               )}

//             </div>

//           </>

//         )}


//         {!loading &&
//           !error &&
//           dignitaries.length ===
//             0 && (

//             <div className="vip-admin-empty">

//               Enter your admin key and
//               click Fetch VIPs.

//             </div>

//           )}


//         <Link
//           to="/"
//           className="vip-admin-back"
//         >

//           ← Back Home

//         </Link>

//       </motion.section>

//     </div>

//   );

// }



import React, {
  useMemo,
  useState,
} from 'react';

import {
  Link,
  useNavigate,
} from 'react-router-dom';

import {
  motion,
} from 'framer-motion';

import './DignitaryList.css';


const isLocalhost = typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1', '::1', '[::1]'].includes(window.location.hostname);
const API_URL = String(
  process.env.REACT_APP_API_URL ||
  (isLocalhost
    ? process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:3001'
    : process.env.REACT_APP_LIVE_API_URL || 'https://lsdcnodejs-api.onrender.com')
).trim().replace(/\/+$/, '');


const PasswordEyeIcon = ({ visible }) => (
  visible ? (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M3 3L21 21"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M10.6 10.7A2 2 0 0013.3 13.4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M9.9 4.3A10.6 10.6 0 0112 4c5.4 0 9 5.2 9 5.2a14.4 14.4 0 01-3 3.6M6.1 6.1C4.2 7.3 3 9.2 3 9.2S6.6 14.4 12 14.4c1 0 1.9-.2 2.7-.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M3 12s3.6-5.2 9-5.2S21 12 21 12s-3.6 5.2-9 5.2S3 12 3 12z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="2.6"
        stroke="currentColor"
        strokeWidth="1.8"
      />
    </svg>
  )
);


const passwordWrapStyle = {
  position: 'relative',
  width: '100%',
};


const passwordInputStyle = {
  width: '100%',
  boxSizing: 'border-box',
  paddingRight: '48px',
};


const passwordEyeButtonStyle = {
  position: 'absolute',
  top: '50%',
  right: '14px',
  transform: 'translateY(-50%)',
  width: '32px',
  minWidth: '32px',
  height: '32px',
  minHeight: '32px',
  padding: 0,
  margin: 0,
  display: 'grid',
  placeItems: 'center',
  border: 'none',
  borderRadius: '50%',
  background: 'transparent',
  boxShadow: 'none',
  color: '#c6a15b',
  cursor: 'pointer',
  zIndex: 3,
};



/* =========================================================
   INVITATION / KINGCHAT HELPERS

   Same message as DignitarySuperMin (Copy Invite Message).
   This is a manual workflow; no automatic KingsChat send.
========================================================= */

const normalizeKcUsername = (value) =>
  String(value ?? '')
    .trim()
    .replace(/^@+/, '')
    .toLowerCase();


const getKcUsername = (person) =>
  normalizeKcUsername(
    person?.kcusername ||
    person?.kc_username ||
    ''
  );


const getKingsChatProfileUrl = (person) => {
  const username = getKcUsername(person);
  return username
    ? `https://kingschat.online/user/${encodeURIComponent(username)}`
    : '';
};


const INVITATION_BASE_URL = (process.env.REACT_APP_INVITATION_BASE_URL || 'https://celebratingcos.site').replace(/\/+$/, '');

const getInvitationLink = (person) => {
  const code = String(person?.invitationCode || '').trim();
  return code
    ? `${INVITATION_BASE_URL}/invitation/${encodeURIComponent(code)}`
    : '';
};


const formatInviteeSalutation = (fullName = '') => {
  const name = String(fullName || '').trim();
  if (!name) return 'Esteemed Guest';
  return /^esteemed\b/i.test(name) ? name : `Esteemed ${name}`;
};


const buildInvitationMessage = (person) => {
  const name = formatInviteeSalutation(person?.fullName);
  const link = getInvitationLink(person);
  const tableLine = person?.tableName
    ? `\n*Your Banquet Table*: ${person.tableName}\n`
    : '';

  if (String(person?.dignitaryLevel || 'VIP').trim().toUpperCase() === 'VVIP') {
    const salutationName = name;
    return `SPECIAL ACCESS: BIRTHDAY THANKSGIVING & BANQUET OF THE HIGHLY ESTEEMED CHIEF OF STAFF, LOVEWORLD NATION; PASTOR BISOLA ADEYEMI

Dear ${salutationName},

Greetings in the precious Name of our Lord Jesus Christ.

Further to your invitation to the Birthday Celebration of our Esteemed Chief of Staff, Pastor Bisola Adeyemi, we are pleased to provide your official access details for the Banquet.

Event Details:

Thanksgiving Service:
Bay 4 — 10:00 a.m. prompt

Banquet:
The Angel Court — Immediately after the Thanksgiving Service

Kindly click the link below to access your Banquet Pass and Table Number:

Access Link:
${link}

We look forward to welcoming you and sharing in this special celebration.

Thank you,
The Organising Committee`;
  }

  return `*SPECIAL INVITATION TO THE BIRTHDAY CELEBRATION, THANKSGIVING AND BANQUET OF THE HIGHLY ESTEEMED CHIEF OF STAFF, LOVEWORLD NATION; PASTOR BISOLA ADEYEMI*

Dear ${name},

Greetings in the precious Name of our Lord Jesus Christ.

We are delighted to invite you to the Birthday Celebration of our Highly Esteemed Chief of Staff, Pastor Bisola Adeyemi, scheduled to hold on *Tuesday, 6th October 2026*.

*Event Details:*
*Thanksgiving Service*: Bay 4, 10am prompt

*Banquet*: The Angel Court, Immediately after the Thanksgiving
${tableLine}
Kindly click the link below to confirm your attendance, so your SEAT NUMBER can be sent to you.

Link:
${link}

We look forward to warmly welcoming you.

Kind regards,
*The Organising Committee*`;
};


/* Copy supports both secure clipboard and a legacy fallback. */
const copyTextToClipboard = async (text) => {
  const value = String(text || '').trim();
  if (!value) throw new Error('Nothing available to copy.');

  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(value);
      return;
    } catch {
      // Try the fallback below when browser permissions reject access.
    }
  }

  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  const ok = document.execCommand('copy');
  textarea.remove();
  if (!ok) throw new Error('Could not copy message.');
};


export default function DignitaryList() {

  const navigate =
    useNavigate();


  const [
    adminKey,
    setAdminKey,
  ] = useState(
    () =>
      sessionStorage.getItem(
        'birthday_admin_key'
      ) || ''
  );


  const [
    showAdminKey,
    setShowAdminKey,
  ] = useState(false);


  const [
    dignitaries,
    setDignitaries,
  ] = useState([]);


  const [
    loading,
    setLoading,
  ] = useState(false);


  const [
    error,
    setError,
  ] = useState('');


  const [
    search,
    setSearch,
  ] = useState('');


  const [
    copiedCode,
    setCopiedCode,
  ] = useState('');

  const [
    copiedMessage,
    setCopiedMessage,
  ] = useState('');

  const [
    preparedInvite,
    setPreparedInvite,
  ] = useState('');

  const [tableEdits, setTableEdits] = useState({});
  const [savingTableFor, setSavingTableFor] = useState('');
  const [tableSavedFor, setTableSavedFor] = useState('');


  /**
   * ==========================
   * FETCH DIGNITARIES
   * ==========================
   */

  const fetchDignitaries =
    async (event) => {

      if (event) {
        event.preventDefault();
      }


      const key =
        adminKey.trim();


      if (!key) {

        setError(
          'Enter your admin key.'
        );

        return;
      }


      try {

        setLoading(true);

        setError('');


        const response =
          await fetch(
            `${API_URL}/api/birthday/admin/dignitaries`,
            {
              method:
                'GET',

              headers: {
                'x-admin-key':
                  key,
              },
            }
          );


        const result =
          await response.json();


        if (
          !response.ok ||
          !result.success
        ) {

          throw new Error(
            result.message ||
              'Unable to fetch dignitaries.'
          );

        }


        sessionStorage.setItem(
          'birthday_admin_key',
          key
        );


        const people = Array.isArray(result.data) ? result.data : [];
        setDignitaries(people);
        setTableEdits(
          Object.fromEntries(
            people.map((person) => [
              String(person.id),
              person.tableName || '',
            ])
          )
        );

      } catch (err) {

        setDignitaries([]);

        setError(
          err.message ||
            'Unable to fetch dignitaries.'
        );

      } finally {

        setLoading(false);

      }

    };


  /**
   * ==========================
   * FILTER
   * ==========================
   */

  const filtered =
    useMemo(() => {

      const query =
        search
          .trim()
          .toLowerCase();


      if (!query) {

        return dignitaries;

      }


      return dignitaries.filter(
        (dignitary) => {

          const fullName =
            String(
              dignitary.fullName ||
                ''
            ).toLowerCase();


          const tableName = String(dignitary.tableName || '').toLowerCase();
          const kcUsername = getKcUsername(dignitary);
          const invitationCode =
            String(
              dignitary.invitationCode ||
                ''
            ).toLowerCase();


          return (
            fullName.includes(
              query
            ) ||
            invitationCode.includes(
              query
            ) ||
            tableName.includes(query) ||
            kcUsername.includes(query)
          );

        }
      );

    }, [
      dignitaries,
      search,
    ]);


/* =========================================================
   SET INDIVIDUAL BANQUET TABLE NAME (ADMIN ONLY)
========================================================= */
const saveTableName = async (person) => {
  const id = String(person.id || '');
  const tableName = String(tableEdits[id] ?? '').trim();
  if (!id || !adminKey.trim()) {
    setError('Provide the admin key and fetch dignitaries first.');
    return;
  }
  if (tableName.length > 80) {
    setError('A table name cannot be longer than 80 characters.');
    return;
  }
  try {
    setSavingTableFor(id);
    setTableSavedFor('');
    setError('');
    const response = await fetch(
      `${API_URL}/api/birthday/admin/dignitaries/${encodeURIComponent(id)}/table-name`,
      {
        method: 'PATCH',
        headers: {
          'x-admin-key': adminKey.trim(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tableName }),
      }
    );
    const result = await response.json();
    if (!response.ok || !result.success) {
      throw new Error(result.message || 'Could not save table name.');
    }
    const savedName = result.data?.tableName || '';
    setDignitaries((current) => current.map((item) =>
      String(item.id) === id ? { ...item, tableName: savedName } : item
    ));
    setTableEdits((current) => ({ ...current, [id]: savedName }));
    setTableSavedFor(id);
  } catch (error) {
    setError(error.message || 'Could not save table assignment.');
  } finally {
    setSavingTableFor('');
  }
};


  /**
   * ==========================
   * COPY CODE
   * ==========================
   */

  const copyCode =
    async (code) => {

      try {

        await copyTextToClipboard(
          code
        );


        setCopiedCode(
          code
        );


        setTimeout(
          () => {
            setCopiedCode('');
          },
          1500
        );

      } catch {

        setError(
          'Unable to copy invitation code.'
        );

      }

    };


  /* =========================================================
     COPY PERSONALISED INVITATION MESSAGE
  ========================================================= */
  const copyInviteMessage = async (person) => {
    try {
      setError('');
      await copyTextToClipboard(buildInvitationMessage(person));
      const code = person.invitationCode;
      setCopiedMessage(code);
      setTimeout(() => setCopiedMessage(''), 1800);
    } catch {
      setError('Unable to copy this invitation message.');
    }
  };


  /* =========================================================
     SEND INVITE (MANUAL KINGCHAT)

     The <a> opens a real KingsChat profile from the click.
     We start the clipboard operation synchronously within
     the click to preserve browser permission. The admin then
     pastes and sends the invitation inside KingsChat.
  ========================================================= */
  const prepareKingsChatInvite = (person) => {
    setError('');
    const code = person.invitationCode;
    const message = buildInvitationMessage(person);

    // Start copying while the user activation is still active.
    copyTextToClipboard(message)
      .then(() => {
        setPreparedInvite(code);
        setTimeout(() => setPreparedInvite(''), 2500);
      })
      .catch(() => {
        setError(
          'KingsChat opened, but the message could not be copied. Use Copy Message, then paste it in KingsChat.'
        );
      });
  };


  /**
   * ==========================
   * OPEN INVITATION
   * ==========================
   */

  const openInvitation =
    (code) => {

      navigate(
        `/invitation/${encodeURIComponent(
          code
        )}`
      );

    };


  return (

    <div className="vip-admin-page">


      <motion.section

        className="vip-admin-card"

        initial={{
          opacity: 0,
          y: 20,
        }}

        animate={{
          opacity: 1,
          y: 0,
        }}

      >

        <span className="vip-admin-eyebrow">

          COS Birthday Celebration

        </span>


        <h1>

          VIP Invitations

        </h1>


        <p className="vip-admin-intro">

          View your dignitaries, copy personalised invite messages,
          and open their KingsChat profiles to send each invitation.

        </p>


        {/* ==========================
            ADMIN ACCESS
        ========================== */}

        <form
          className="vip-admin-login"
          onSubmit={
            fetchDignitaries
          }
        >

          <label htmlFor="vip-admin-key">

            Admin Key

          </label>


          <div className="vip-admin-login-row">

            <div style={passwordWrapStyle}>

              <input

                id="vip-admin-key"

                type={
                  showAdminKey
                    ? 'text'
                    : 'password'
                }

                placeholder="Enter admin key"

                value={
                  adminKey
                }

                onChange={(
                  event
                ) => {

                  setAdminKey(
                    event.target.value
                  );

                  if (error) {
                    setError('');
                  }

                }}

                autoComplete="off"

                style={passwordInputStyle}

              />


              <button
                type="button"
                onClick={() =>
                  setShowAdminKey(
                    (current) => !current
                  )
                }
                aria-label={
                  showAdminKey
                    ? 'Hide admin key'
                    : 'Show admin key'
                }
                title={
                  showAdminKey
                    ? 'Hide password'
                    : 'Show password'
                }
                style={passwordEyeButtonStyle}
              >
                <PasswordEyeIcon
                  visible={showAdminKey}
                />
              </button>

            </div>


            <button
              type="submit"
              disabled={
                loading
              }
            >

              {loading
                ? 'Loading...'
                : 'Fetch VIPs'}

            </button>

          </div>

        </form>


        {error && (

          <div
            className="vip-admin-error"
            role="alert"
          >

            {error}

          </div>

        )}


        {/* ==========================
            RESULT AREA
        ========================== */}

        {dignitaries.length > 0 && (

          <>

            <div className="vip-admin-toolbar">

              <div>

                <strong>
                  {
                    dignitaries.length
                  }
                </strong>

                <span>
                  {' '}
                  dignitar{
                    dignitaries.length ===
                    1
                      ? 'y'
                      : 'ies'
                  }
                </span>

              </div>


              <input

                type="search"

                placeholder="Search name, KingsChat, table or invitation code..."

                value={
                  search
                }

                onChange={(
                  event
                ) =>
                  setSearch(
                    event.target.value
                  )
                }

              />

            </div>


            <div className="vip-admin-list">

              {filtered.length >
              0 ? (

                filtered.map(
                  (
                    dignitary,
                    index
                  ) => (

                    <motion.div

                      className="vip-admin-row"

                      key={
                        dignitary.id ||
                        dignitary.invitationCode
                      }

                      initial={{
                        opacity: 0,
                        y: 10,
                      }}

                      animate={{
                        opacity: 1,
                        y: 0,
                      }}

                      transition={{
                        delay:
                          Math.min(index, 12) *
                          0.025,
                      }}

                    >

                      <div className="vip-admin-number">

                        {String(
                          index + 1
                        ).padStart(
                          2,
                          '0'
                        )}

                      </div>


                      <div className="vip-admin-person">

                        <span>
                          Full Name
                        </span>

                        <strong>
                          {
                            dignitary.fullName
                          }
                        </strong>

                        {getKcUsername(dignitary) ? (
                          <span className="vip-admin-kcusername">
                            KingsChat · @{getKcUsername(dignitary)}
                          </span>
                        ) : (
                          <span className="vip-admin-kcusername vip-admin-kcusername--missing">
                            No KingsChat username on record
                          </span>
                        )}

                      </div>


                      <div className="vip-admin-code">

                        <span>
                          Invitation Code
                        </span>

                        <strong>
                          {
                            dignitary.invitationCode
                          }
                        </strong>

                      </div>


<div className="vip-admin-table-assignment">
  <label htmlFor={`table-${dignitary.id}`}>
    Banquet Table Name
  </label>
  <input
    id={`table-${dignitary.id}`}
    type="text"
    maxLength={80}
    value={tableEdits[String(dignitary.id)] ?? dignitary.tableName ?? ''}
    placeholder="e.g. Table of Grace"
    onChange={(event) => {
      const id = String(dignitary.id);
      setTableEdits((current) => ({
        ...current,
        [id]: event.target.value,
      }));
      if (tableSavedFor === id) setTableSavedFor('');
    }}
  />
  <button
    type="button"
    onClick={() => saveTableName(dignitary)}
    disabled={savingTableFor === String(dignitary.id)}
  >
    {savingTableFor === String(dignitary.id)
      ? 'Saving…'
      : tableSavedFor === String(dignitary.id)
        ? 'Table Saved ✓'
        : 'Save Table'}
  </button>
  {dignitary.tableName ? (
    <small>Current: {dignitary.tableName}</small>
  ) : (
    <small>Not yet assigned</small>
  )}
</div>

                      <div className="vip-admin-actions">

                        <button
                          type="button"
                          onClick={() =>
                            copyCode(
                              dignitary.invitationCode
                            )
                          }
                        >

                          {copiedCode ===
                          dignitary.invitationCode
                            ? 'Copied ✓'
                            : 'Copy Code'}

                        </button>


                        <button
                          type="button"
                          className="vip-admin-copy-message"
                          onClick={() => copyInviteMessage(dignitary)}
                          disabled={!dignitary.invitationCode}
                        >
                          {copiedMessage === dignitary.invitationCode
                            ? 'Message Copied ✓'
                            : 'Copy Message'}
                        </button>

                        {getKingsChatProfileUrl(dignitary) ? (
                          <a
                            className="vip-admin-send"
                            href={getKingsChatProfileUrl(dignitary)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => prepareKingsChatInvite(dignitary)}
                            title="Open KingsChat profile and copy message to paste"
                          >
                            {preparedInvite === dignitary.invitationCode
                              ? 'Copied · Ready to Paste ✓'
                              : 'Send Invite'}
                          </a>
                        ) : (
                          <button
                            type="button"
                            className="vip-admin-send"
                            disabled
                            title="KingsChat username is missing"
                          >
                            Send Invite
                          </button>
                        )}

                        <button
                          type="button"
                          className="vip-admin-open"
                          onClick={() =>
                            openInvitation(
                              dignitary.invitationCode
                            )
                          }
                        >

                          View Invite

                        </button>

                      </div>

                    </motion.div>

                  )
                )

              ) : (

                <div className="vip-admin-empty">

                  No dignitary matches
                  your search.

                </div>

              )}

            </div>

          </>

        )}


        {!loading &&
          !error &&
          dignitaries.length ===
            0 && (

            <div className="vip-admin-empty">

              Enter your admin key and
              click Fetch VIPs.

            </div>

          )}


        <Link
          to="/"
          className="vip-admin-back"
        >

          ← Back Home

        </Link>

      </motion.section>

    </div>

  );

}